import { useEffect, useState } from 'react';

/**
 * A hook that tracks if the document currently has focus
 * @returns Current focus state of the document
 */
const useDocumentFocus = (): boolean => {
    const [isFocused, setIsFocused] = useState(document.hasFocus());

    useEffect(() => {
        const handleFocus = () => setIsFocused(true);
        const handleBlur = () => setIsFocused(false);

        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);

        return () => {
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
        };
    }, []);

    return isFocused;
};

export default useDocumentFocus;
